import { initializeApp } from "firebase/app";
import { getRemoteConfig, fetchAndActivate, getValue } from "firebase/remote-config";
import * as defaults from "../constants/defaults";
import { environment } from "../build_environment";

// -----------------------
//       next-dev DEV
// -----------------------
const config_dev = {
  apiKey: "AIzaSyC4vBkYNe4VILCOTT5UKfTWwgjV-Y9OJOg",
  authDomain: "afinando-o-cerebro-dev.firebaseapp.com",
  projectId: "afinando-o-cerebro-dev",
  storageBucket: "afinando-o-cerebro-dev.appspot.com",
  messagingSenderId: "805037471160",
  appId: "1:805037471160:web:16e0a0d8f7ab8fb8d04b4d",
  measurementId: "G-1QN3LQ0BKY"
};

// -----------------------
//       next-dev PROD
// -----------------------
const config_prod = {
  apiKey: "AIzaSyAHDQ4nHNRd9vsdjf9SAqjycHlSamLIbhw",
  authDomain: "afindando-o-cerebro.firebaseapp.com",
  projectId: "afindando-o-cerebro",
  storageBucket: "afindando-o-cerebro.appspot.com",
  messagingSenderId: "886275793871",
  appId: "1:886275793871:web:a48eae5edbcc0ef54ae8ba",
  measurementId: "G-2J0P65FBJS"
};

export const remote_config_defaults = {
  "types_user": "{\"individual\":{\"title\":\"Individual Profile\"},\"parent\":{\"title\":\"Parent Profile\"},\"patient\":{\"title\":\"Patient Profile\"}}",
  "appConfig" : {
    "API_URL_DEV": "https://k9357p16ih.execute-api.us-east-1.amazonaws.com/next-dev-2",
    "API_URL_PROD": "https://mcqj5lejdg.execute-api.us-east-1.amazonaws.com/v1"
  }
};

export const RUNNING_ENVIROMENT = environment;

const config = environment === defaults.DEV ? config_dev : config_prod;

// Inicializar Firebase App
const app = initializeApp(config);

// Configurar e usar Remote Config
const remoteConfig = getRemoteConfig(app);
remoteConfig.defaultConfig = remote_config_defaults; // Valores padrão
remoteConfig.settings = {
  minimumFetchIntervalMillis: 3600000, // Tempo mínimo entre as atualizações
};

// Função para buscar valores do Remote Config
export async function fetchRemoteValue(key) {
  try {
    await fetchAndActivate(remoteConfig);
     // Ativar e buscar os valores mais recentes
    return getValue(remoteConfig, key).asString(); // Retornar o valor da chave
  } catch (error) {
    console.error(`Erro ao buscar a chave ${key} do Remote Config:`, error);
    return remoteConfig.defaultConfig[key]; // Retornar valor padrão em caso de erro
  }
}

export default config;
